// import { useState } from "react";
// import { View, StyleSheet, Text, Modal, Pressable, FlatList } from "react-native";
// import { Ionicons } from "@expo/vector-icons";
// import { appColors, cardShadow } from "../../constants/colors";

// export default function CustomDropdown({ list, onMonthChange }) {
//   const [visible, setVisible] = useState(false);
//   const [selected, setSelected] = useState("");

//   const onItemPress = item => {
//     setVisible(false);
//     setSelected(item);
//     onMonthChange(item);
//   };

//   const monthNum = selected || list[0];

//   return (
//     <View style={styles.container}>
//       <Pressable style={styles.button} onPress={() => setVisible(v => !v)}>
//         <Modal visible={visible} transparent animationType="slide">
//           <Pressable style={styles.overlay} onPress={() => setVisible(false)}>
//             <View style={styles.dropdown}>
//               <FlatList
//                 data={list}
//                 keyExtractor={(item, index) => index.toString()}
//                 renderItem={({ item }) => (
//                   <Pressable
//                     style={({ pressed }) => [styles.item, pressed && styles.itemPressed]}
//                     onPress={() => onItemPress(item)}
//                   >
//                     <Text style={styles.itemText}>{`Month ${item}`}</Text>
//                   </Pressable>
//                 )}
//               />
//             </View>
//           </Pressable>
//         </Modal>

//         <Text style={styles.buttonText}>{`Month ${monthNum}`}</Text>
//         <Ionicons color={appColors.primary} size={16} name="chevron-down" />
//       </Pressable>
//     </View>
//   );
// }

// const styles = StyleSheet.create({
//   container: {
//     width: "100%",
//     alignItems: "center",
//     overflow: "hidden",
//   },

//   button: {
//     flexDirection: "row",
//     alignItems: "center",
//     paddingHorizontal: 10,
//     paddingVertical: 5,
//     width: "100%",
//   },

//   buttonText: {
//     flex: 1,
//     color: appColors.textPrimary,
//     textAlign: "center",
//     fontSize: 12,
//   },

//   overlay: {
//     flex: 1,
//     alignItems: "center",
//     justifyContent: "center",
//     paddingVertical: "15%",
//     backgroundColor: "rgba(5,30,60,0.6)",
//   },

//   dropdown: {
//     backgroundColor: appColors.cardBg,
//     width: "90%",
//     borderRadius: 12,
//     overflow: "hidden",
//     padding: 4,
//     maxHeight: 300,
//     ...cardShadow("large"),
//   },

//   item: {
//     paddingHorizontal: 14,
//     paddingVertical: 10,
//     borderBottomWidth: 0.5,
//     borderBottomColor: appColors.borderLight,
//   },

//   itemPressed: {
//     backgroundColor: appColors.inputBg,
//   },

//   itemText: {
//     fontSize: 13,
//     color: appColors.textPrimary,
//   },
// });

import { useState } from "react";
import { View, StyleSheet, Text, Modal, Pressable, FlatList } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { appColors, cardShadow } from "../../constants/colors";

export default function CustomDropdown({ list, onMonthChange, value }) {
  const [visible, setVisible] = useState(false);

  const onItemPress = item => {
    setVisible(false);
    onMonthChange(item);
  };

  const monthNum = value || list[0];

  return (
    <View style={styles.container}>
      <Pressable style={styles.button} onPress={() => setVisible(v => !v)}>
        <Modal visible={visible} transparent animationType="slide">
          <Pressable style={styles.overlay} onPress={() => setVisible(false)}>
            <View style={styles.dropdown}>
              <FlatList
                data={list}
                keyExtractor={(item, index) => index.toString()}
                renderItem={({ item }) => (
                  <Pressable
                    style={({ pressed }) => [styles.item, pressed && styles.itemPressed]}
                    onPress={() => onItemPress(item)}
                  >
                    <Text style={styles.itemText}>{`Month ${item}`}</Text>
                  </Pressable>
                )}
              />
            </View>
          </Pressable>
        </Modal>

        <Text style={styles.buttonText}>{`Month ${monthNum}`}</Text>
        <Ionicons color={appColors.primary} size={16} name="chevron-down" />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    alignItems: "center",
    overflow: "hidden",
  },

  button: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingVertical: 5,
    width: "100%",
  },

  buttonText: {
    flex: 1,
    color: appColors.textPrimary,
    textAlign: "center",
    fontSize: 12,
  },

  overlay: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: "15%",
    backgroundColor: "rgba(5,30,60,0.6)",
  },

  dropdown: {
    backgroundColor: appColors.cardBg,
    width: "90%",
    borderRadius: 12,
    overflow: "hidden",
    padding: 4,
    maxHeight: 300,
    ...cardShadow("large"),
  },

  item: {
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderBottomWidth: 0.5,
    borderBottomColor: appColors.borderLight,
  },

  itemPressed: {
    backgroundColor: appColors.inputBg,
  },

  itemText: {
    fontSize: 13,
    color: appColors.textPrimary,
  },
});
